export default function() {
  return this._root;
}



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/d3-quadtree/src/root.js
// module id = ../../../../d3-quadtree/src/root.js
// module chunks = 4